export default {
  requests: {
    iin: "ЖСН",
    fio: "Т.А.Ә.",
    create: "Шарт жасасуға өтінім беру",
    delete: "Өтінімді өшіру",
    req_saved: "Өтінім сақталды",
    req_signed: "Өтінімге қол қойылды",
    plan_saved: "Жеткізу жоспары сақталған. Енді өтінімді келісуге жіберуге болады.",
    delete_file: "Жою",
    add_file: "Қосу",
    view: "Шартты қарау",
    attachments: "Тіркелген құжаттар",
    edit: "Өтінімді өзгерту",
    supply: "Электр энергиясын жеткізу бойынша алдын ала өтінім толтыру",
    send: "Қарастыруға жіберу",
    req: "Өтінім беру күні",
    number: "Өтінім нөмірі",
    last_action: "Өтінім мәртебесінің соңғы өзгерген күні",
    status: "Өтінімнің ағымдағы мәртебесі",
    comment: "«АлматыЭнергоСбыт» ЖШС-нің түсініктемесі",
    contract: "Шарт нөмірі",
    region_name: "Аймақ",
    bank_name: "Банк",
    iik_number: "ЖСК",
    ap_fact_address2: "Энергиямен жабдықтау объектісінің мекенжайы",
    is_resident: "ҚР-ның резиденті",
    assigned_power: "Қуаты кВт",
    azhk_org_branch: "АЖК АҚ ЭТА (бөлу актісінде көрсетілген)",
    phone_number: "Байланыс телефоны",
    email: "Электрондық пошта мекенжайы",
    org_type: "Ұйымдық-құқықтық нысаны",
    contractor_name: "Ұйымның атауы",
    contractor_jur_address2: "Заңды мекенжайы (ЖК және жеке тұлғалар үшін тіркелген (тіркелім) жері бойынша мекенжайы көрсетіледі)",
    contractor_fact_address2: "Нақты мекенжайы (егер анықтамалықта жоқ болса)",
    boss_pos_name: "Басшының лауазымы",
    boss_fio: "Басшының Т.А.Ә.",
    accept: "Мен жеке деректерді өңдеуге келісемін",
    private: "Берілетін ақпараттың дұрыстығы үшін жауапкершілікті өтініш беруші көтереді",
    save: "Сақтау",
    attach_type_name: "Құжат түрі",
    attach_file_name: "Файлдың аты",
    attach_file_type: "Файлдың түрі",
    action: "Іс-әрекет",
    send_supply: "Электр энергиясын жеткізу жөнінде алдын ала өтінімді толтыру",
    send_supply2:
      "Электр энергиясын жеткізу жөнінде алдын ала өтінімді толтыру",
    send_supply_req: "Заявка о поставке электроэнергии",
    title_new: "1 қадам. Шарт жасасуға өтінім",
    title_attach: "2 қадам. Құжаттарды қосыңыз",
    post_adres: "Пошталық мекенжайы",
    phone_messages: "Мессенджерлерге арналған ұялы нөмір",
    phone_multimedia: "Мультимедиялық хабарға арналған ұялы нөмір",
    phone_mobile: "Ұялы нөмір",
    email_accept: "Email",
    BIK: "БСК",
    message_for_accept:
      "Құрметті {name}, электрмен жабдықтау шартының акцепті туралы өтініш беру үшін келесі жолдарды толтыру қажет",
    sign_contract: "Шартқа қол қою",
    view_accept: "Акцептіні қарау",
    view_request: "Өтінішті қарау",
    kvt: "кВт.ч.",
    "invalid-phone": "Телефон нөмірі қате",
  },
  ru: "RU",
  kk: "KZ",
  hello: "Salem",
  attention: "Назар аударыңыз",
  cancel: "Бас тарту",
  update: "Жаңарту",
  close: "Жабу",
  "no-data": "Деректер жоқ",
  back: "Кері қарай",
  summary: "Барлығы",
  expand: "Кеңейту",
  ui: {
    print: "Басып шығару",
    labels: {
      yes: "Иә",
      no: "Жоқ",
      close: "Жабу",
    },
    wait: "Күтуіңізді сұраймыз...",
    document_loading:
      "Сіздің құжатыңыз жүктелуде және ол осы терезеде ашылатын болады. Күтуіңізді сұраймыз...",
    list_all: "Барлығы",
    no_data_for_period: "Таңдалған кезеңде деректер жоқ",
    "date-picker": {
      label: "Кезеңді таңдаңыз",
      from: "бастап",
      to: "дейін",
    },
    errors: {
      timeout: "Пайдаланушылар саны артты.<br/>Кейінірек кіруіңізді сұраймыз",
    },
  },
  "update-checker": {
    message:
      'Жеке кабинеттің жаңа нұсқасы қол жетімді.<br /><br />Жаңарту керек пе?<br /><br /> Бетті қайта жүктеу үшін "Жаңарту" түймесін басыңыз.Барлық енгізілген деректер жоғалады.',
  },
  maintenance: {
    message:
      '<center><b>Назар аударыңыз!</b> <br /><br /> <span style="font-weight: 400"> Техникалық жұмыстар жүргізілуде. <br /><br /> Келтірілген қолайсыздықтар үшін кешірім сұраймыз.</span> </center>',
  },
  "app-header": {
    feedback: "Кері байланыс",
    "contact-center":
      "Тәулік бойы жұмыс істейтін Контакт орталығы 356-99-99, 399-99-00",
    departments: "АлматыЭнергоСбыт аудандық бөлімшелері (АЭЖБ)",
  },
  "app-navigation": {
    contract: "Шарт",
    "contract-placeholder": "Нөмірді таңдаңыз",
    bin: "БСН",
    organization: "Ұйым",
    "home-tooltip": "Өтінімдер тізімі",
    "profile-tooltip": "Бейін",
    "exit-tooltip": "Шығу",
    "pay-tooltip": "Төлеу",
    "appeal-tooltip":
      "Менің өтініштерім. Ұсыныстар мен өтініштер жіберуге және «АлматыЭнергоСбыт» ЖШС-нен жауаптар алуға арналған кері байланыс нысаны",
    contracts:
      "Шарт туралы жалпы ақпарат: жасалған күні, көрсеткіштерді ұсыну күні",
    abonent:
      "Мұнда сіздің деректемелеріңіз көрсетілген: ҚҚС бойынша есепке қою туралы куәлік, қызметкерлер туралы ақпарат",
    points:
      "Орнатылған есепке алу құралдары, пломбалар және ток трансформаторлары туралы ақпарат, тарифтер, ТҚС",
    calcs:
      "Қызметтер мен кезеңдер бойынша есептеулер мен төлемдер туралы ақпаратты қарау",
    actions:
      "Көрсеткіштерді беру, Салыстыру актісін және Орындалған жұмыстар актісін алу және жіберу",
    notices: "Қарыз туралы хабарламаларды қарау",
    reports:
      "Құжаттарды қарау: өзара есеп айырысуларды салыстыру актілері, орындалған жұмыстардың актілері, төлем шоттары, 2-қосымша",
    invoices: "Шот-фактураларды қарау",
  },
  "app-menu": {
    "debt-button": "Шарт бойынша қарыз",
    contract: "Шарт",
    abonent: "Тұтынушы",
    "accounting-points": "Есепке алу нүктелері",
    payments: "Есептеу мен төлем",
    "report-forms": "Есептік  нысандар",
    actions: "Шарт бойынша іс-әрекеттер",
    "debt-notifications": "Қарыз туралы хабарламалар",
    invoices: "Шот-фактуралар",
  },
  "app-footer": {
    text: "АлматыЭнергоСбыт. «АЛСЕКО» АҚ әзірлеген",
  },
  "auth-view": {
    title: "Өтінімдер",
    enter: "Кіру",
    form: {
      title: "ЭСҚ-сыз кiру",
      "enter-bin": "БСН енгізіңіз",
      "enter-iin": "ЖСН енгізіңіз",
      "credentials-title": "Өкілеттікті таңдаңыз",
    },
    "form-eds": {
      title: "ЭСҚ арқылы кіру",
    },
    manuals: {
      "video-inctruction": {
        title: "Жеке кабинет жұмысының бейне нұсқаулығын карау",
        href: "https://esalmaty.kz/kz/i3399",
      },
      "get-eds": {
        title: "Заңды тұлғалар үшін ЭЦҚ алу",
        href: "https://egov.kz/cms/kk/information/eds/getecpiio",
      },
    },
  },
  credentials: {
    individual: "Жеке тұлға",
    legal: "Заңды тұлға",
    "first-leader": "Заңды тұлғаның қол қоюға құқылы бірінші басшысы",
    signer: "Қол қою құқығы бар тұлға",
    "financial-signer": "Қаржылық құжаттарға қол қою құқығы бар тұлға",
    hr:
      "Заңды тұлға қызметкерлерінен берілген тіркеу куәліктерін шығаруға арналған өтінімдерді растау құқығы берілген кадр бөлімінің қызметкері",
    employee: "Ұйымның қызметкері",
  },
  "form-validator": {
    required: "Міндетті түрде толтырылуы қажет жол",
    "string-max": "Жолдың максималды ұзындығы {max} таңба",
    "string-min": "Жолдың минималды ұзындығы {min} таңба",
    bin: "БСН форматы қате",
    iin: "ЖСН форматы қате",
    email: "Қате email енгізілген",
  },
  storages: {
    computer: "Сіздің компьютеріңіз",
    "kaz-token": "Казтокен",
    "id-card": "Жеке куәлік",
    "e-token": "EToken Java 72k",
    "ak-ja-carta": "AK JaCarta",
  },
  eds: {
    sign: "Қол қою",
    reject: "Қабылдамау",
    "sign-with-eds": "ЭЦҚ арқылы қол қою",
    error:
      "Электрондық цифрлық қолтаңба кілттерімен жұмыс істеу үшін NCALayer бағдарламасын орнатыңыз немесе іске қосыңыз",
  },
  profile: {
    title: "Бейін",
    organization: {
      title: "Ұйым бойынша мәліметтер",
      "bin-iin": "БСН/ЖСН",
      name: "Атауы",
      email: {
        title: "Email",
        placeholder: "Email-ді енгізіңіз",
        edit: "Email-ді өзгерту",
        save: "Email-ді сақтау",
        cancel: "Email-дің өзгеруін болдырмау",
        "not-verified": "Сіздің электрондық мекен-жайыңыз расталған жоқ",
        "card-no-email":
          "Электрондық мекен-жай енгізілмеген. Жеке кабинеттің барлық мүмкіндіктерін пайдалану үшін Сіздің электрондық мекен-жайыңызды енгізіп, растаңыз",
        "card-title": "Email-ды растау",
        "card-not-verified":
          "Сіздің электрондық мекен-жайыңыз{email} расталған жоқ. <br />Жеке кабинеттің барлық мүмкіндіктерін пайдалану үшін электрондық мекен-жайды растау қажет.",
        "card-link": "Растау сілтемесін қайта жіберу",
        "card-text-send":
          "Сіздің {email} электрондық мекен-жайыңызға email-ды растау сілтемесі бар хат жіберілді",
        "card-text-confirm": "Сіздің электрондық мекен-жайыңыз сәтті расталды",
      },
    },
  },
  $vuetify: {
    datePicker: {
      itemsSelected: "{0} таңдалған",
      nextMonthAriaLabel: "Келесі ай",
      nextYearAriaLabel: "Келесі жыл",
      prevMonthAriaLabel: "Алдыңғы ай",
      prevYearAriaLabel: "Алдыңғы жыл",
    },
    dataIterator: {
      rowsPerPageText: "Парақтағы жолдар:",
      rowsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataFooter: {
      rowsPerPageText: "Парақтағы жолдар:",
      itemsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataTable: {
      itemsPerPageText: "Парақтағы жолдар:",
      sortBy: "Cұрыптау",
      ariaLabel: {
        activateAscending: "KZ Активирована сортировка",
        sortNone: "KZ Без сортировки",
        activateNone: "KZ Сортировка не активна",
      },
    },
    noDataText: "Көрсету үшін деректер жоқ",
    carousel: {
      prev: "Предыдущий визуальный",
      next: "Следующий визуальный",
    },
  },
};
